const Breakpoints = {
    navigationBarCollapsed: '1024px',
    bottomBarVisible: '640px',
};
const noop = () => { };
const noWindowMatches = (matches = false) => ({
    media: '',
    addListener: noop,
    removeListener: noop,
    matches,
    onchange: noop,
    addEventListener: noop,
    removeEventListener: noop,
    dispatchEvent: (_) => true,
});
export function isNavigationBarCollapsed() {
    return typeof window === 'undefined'
        ? noWindowMatches()
        : window.matchMedia(`(max-width: ${Breakpoints.navigationBarCollapsed})`);
}
export function isBottomBarVisible() {
    return typeof window === 'undefined'
        ? noWindowMatches()
        : window.matchMedia(`(max-width: ${Breakpoints.bottomBarVisible})`);
}
//# sourceMappingURL=breakpoints.js.map